export default "__VITE_ASSET__BYDoWjZV__"